/* eslint-disable react/style-prop-object */
import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";

import { useContext, useEffect, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import CustomerInf from "../CustomerInf/CustomerInf";
import { Segmented } from "antd";
import trans from "../../../utils";
import { useGetSingleCustomerQuery } from "../../../Redux/service/Customer/Customer";
import CustomerLocation from "../CustomerInf/CustomerLocation";
import CustomerExtra from "../CustomerInf/CustomerExtra";

export function CustomersPopup({ customerId, type }) {
	let { handleClose, setSubCurrentUserId, edited } = useContext(popupcontext);
	const steps = [
		{ label: trans("information"), value: "information" },
		{ label: trans("location"), value: "location" },
		{ label: trans("extra"), value: "extra" },
	];
	const [activeOption, setActiveOption] = useState("information");

	let { data, isLoading, refetch } = useGetSingleCustomerQuery(customerId, {
		skip: !customerId,
	});
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);
	const closeuser = () => {
		if (type === "customer") {
			handleClose("display");
		} else {
			setSubCurrentUserId(null);
		}
	};
	return (
		<Popup show={!!customerId}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${data?.data?.name}`} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeuser}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={steps.map((i, index) => ({
					label: i.label,
					value: i.value,
				}))}
				style={{ textTransform: "capitalize" }}
				onChange={(value) => {
					console.log("Value", value);
					setActiveOption(value);
				}}
				value={activeOption}
				size="large"
				block
			/>
			<Modal.Body className="modal-body-scrollable">
				{activeOption === "information" && <CustomerInf values={data?.data} />}
				{activeOption === "location" && (
					<CustomerLocation values={data?.data} />
				)}
				{activeOption === "extra" && <CustomerExtra values={data?.data} />}
			</Modal.Body>
		</Popup>
	);
}
